export default __webpack_public_path__ + "static/media/slide2.6f5fb16d.jpg";